
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import GeoJSON from 'ol/format/GeoJSON';

import mapGetActions from '../../sagas/map';
import infoGetActions from '../../sagas/info';

import ContainerWithToolbar from '../common/ContainerWithToolbar';
import ToolbarSeparator from '../common/ToolbarSeparator';
import MapBase from '../map/MapBase';
import ButtonCommandZoomIn from '../map/ButtonCommandZoomIn';
import ButtonCommandZoomOut from '../map/ButtonCommandZoomOut';
import ButtonCommandZoomDefault from '../map/ButtonCommandZoomDefault';
import ButtonCommandTools from '../map/ButtonCommandTools';
import LayerSwitcherButton from '../map/LayerSwitcherButton';

import processMapProject from './processMapProject';
import ObjectInfo from './ObjectInfo';
import MAP_PROJECT from './mapProjectDef';

import IconDefault from '../../icons/map_tool_default.png';
import IconInfoPoint from '../../icons/info_point.png';
import IconInfoPolygon from '../../icons/info_polygon.png';

const classNames = mergeStyleSets({
    layers: {
        position: 'absolute',
        zIndex: 100,
        right: 64,
        padding: 4
    },
    info: {
        position: 'absolute',
        zIndex: 100,
        maxHeight: '100%',
        backgroundColor: '#ffffff',
        borderRight: '1px solid #dddddd',
        borderBottom: '1px solid #dddddd'
    }
});

const ProjectMap = (props) => {

    const dispatch = useDispatch();
    const mapActions = mapGetActions(dispatch);
    const infoActions = infoGetActions(dispatch);

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const map = useSelector(state => {
        return state.map;
    });

    const category = useSelector(state => {
        return state.category;
    });

    useEffect(() => {
        mapActions.initProject(processMapProject(MAP_PROJECT, props.projectId));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.projectId]);

    useEffect(() => {
        if (category.actualCategoryFullName) {
            let arr = category.actualCategoryFullName.split(':');
            mapActions.addCommand(
                'SET_LAYER_PARAMS',
                {
                    layer: 'category_parcela',
                    params: {
                        'list_name': arr[0],
                        'category_name': arr[1]
                    }
                }
            );
            mapActions.addCommand(
                'SET_LAYER_PARAMS',
                {
                    layer: 'category_cluster',
                    params: {
                        'list_name': arr[0],
                        'category_name': arr[1]
                    }
                }
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [category.actualCategoryFullName]);

    const handleChangeView = (center, zoom, rotation, resolution) => {
        mapActions.changeView(center, zoom, rotation, resolution);
    }

    const handleMapClick = (coord) => {
        infoActions.getObjectFromMap(token, props.projectId, coord);
    }

    const handleMapToolExecute = (toolId, params) => {
        switch (toolId) {
            case 'SelectObjectPoint':
            case 'SelectObjectPolygon':
                infoActions.getObjectFromMap(
                    token, props.projectId,
                    (new GeoJSON()).writeGeometry(params.geometry)
                );
                break;
            default:
                // nop;
                break;
        }
    }

    const handleSelectTool = (toolId, tool) => {
        mapActions.addCommand(
            'SET_MAP_TOOL',
            {
                toolId: toolId
            }
        );
    }

    const getProjectExtent = () => {
        return [
            props.projectExtent.xmin,
            props.projectExtent.ymin,
            props.projectExtent.xmax,
            props.projectExtent.ymax
        ]
    }

    const mapButtons = [
        <ButtonCommandZoomIn/>,
        <ButtonCommandZoomOut/>,
        <ButtonCommandZoomDefault defaultExtent={getProjectExtent()} />,
        <ToolbarSeparator />,
        <ButtonCommandTools
            tools={[
                {
                    toolId: 'Default',
                    iconSrc: IconDefault,
                    title: 'Pohyb v mapě'
                },
                {
                    toolId: 'SelectObjectPoint',
                    iconSrc: IconInfoPoint,
                    title: 'Výběr v mapě bodem'
                },
                {
                    toolId: 'SelectObjectPolygon',
                    iconSrc: IconInfoPolygon,
                    title: 'Výběr v mapě polygonem'
                }
            ]}
            onSelectTool={handleSelectTool}
        />
    ];

    return map.definition
        ? (
            <Stack verticalFill>
                <Stack verticalFill>
                    <ContainerWithToolbar toolbarPosition="right" toolbarDirection="" buttons={mapButtons}>
                        <div className={classNames.layers}>
                            <LayerSwitcherButton
                                map={map}
                                layers={map.layers}
                                groups={map.groups}
                                moduleActions={mapActions}
                            />
                        </div>
                        <div className={classNames.info}>
                            <ObjectInfo />
                        </div>
                        <MapBase
                            map={map}
                            layers={map.layers}
                            groups={map.groups}
                            defaultExtent={getProjectExtent()}
                            onChangeView={handleChangeView}
                            onMapClick2={handleMapClick}
                            onMapToolExecute={handleMapToolExecute}
                            moduleActions={mapActions}
                        />
                    </ContainerWithToolbar>
                </Stack>
            </Stack>
        )
        : null;
}

export default ProjectMap;
